import http from '@/libs/axios'

export function getFile(params) {
  return http({
    url: `/files/file/${params.id}`,
    method: 'get',
  })
}

export function uploadFile(data) {
  return http({
    url: '/files/file/',
    method: 'post',
    data,
  })
}

export function getUsers(params) {
  return http({
    url: '/users/users/',
    method: 'get',
    params,
  })
}

export function createUser(data) {
  return http({
    url: '/users/users/',
    method: 'post',
    data,
  })
}

export function getSingleUser(params) {
  return http({
    url: `/users/users/${params.id}/`,
    method: 'get',
  })
}

export function deleteUser(id) {
  return http({
    url: `/users/users/${id}/`,
    method: 'delete',
  })
}

export function updateUser(data) {
  return http({
    url: `/users/users/${data.id || data.get('id')}/`,
    method: 'patch',
    data,
  })
}

// roles
export function getRoles(params) {
  return http({
    url: '/users/roles/',
    method: 'get',
    params,
  })
}

export function createRole(data) {
  return http({
    url: '/users/roles/',
    method: 'post',
    data,
  })
}

export function updateRole(data) {
  return http({
    url: `/users/roles/${data.id}/`,
    method: 'patch',
    data,
  })
}

export function deleteRole(data) {
  return http({
    url: `/users/roles/${data.id}/`,
    method: 'delete',
  })
}

// groups
export function getGroups(params) {
  return http({
    url: '/users/groups/',
    method: 'get',
    params,
  })
}

// /users/user-phones/
export function getUserPhones(params) {
  return http({
    url: '/users/user-phones/',
    method: 'get',
    params,
  })
}

export function addUserPhone(data) {
  return http({
    url: '/users/user-phones/',
    method: 'post',
    data,
  })
}

export function getUsersAsync(params) {
  return http({
    url: '/users/users/',
    method: 'get',
    params,
  })
}

export function updateUserPassword(data) {
  return http({
    url: '/users/users/change_own_password/',
    method: 'patch',
    data,
  })
}

export function getAllChatNotifications(data) {
  return http({
    url: '/chat/notifications/',
    method: 'patch',
    data,
  })
}
